import React from 'react'
import styles from './Checkbox.scss'
import cx from 'classnames'

export class Checkbox extends React.PureComponent {
  render () {
    const { checked, label, onChange, horizontal, onClickOption, disabled, className } = this.props
    return (
      <label onClick={onClickOption} className={cx(styles.label, horizontal && styles.labelHorizontal, className)}>
        <input
          className={styles.checkbox}
          type='checkbox'
          checked={checked}
          disabled={disabled}
          onChange={onChange} />
        {label}
      </label>
    )
  }
}
